import React from 'react';

import PropTypes from 'prop-types';
import momentBusinessDays from 'moment-business-days';
import moment from 'moment';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { DetialLabel, DetialValue } from './css';

const Details = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    orderTracking: {
      orderIdLabel,
      orderSubmissionDate,
      estimatedCompletionDate
    }
  } = localizedStrings;

  const { _d } = momentBusinessDays(orderData.updatedAt).businessAdd(27);
  const completionDate = moment(_d).format('YYYY-MM-DD');

  return (
    <div style={{ marginTop: '2rem' }}>
      <div>
        <DetialLabel>{orderIdLabel}</DetialLabel>
        <DetialValue>{orderData.orderId}</DetialValue>
      </div>
      <div>
        <DetialLabel>{orderSubmissionDate}</DetialLabel>
        <DetialValue>
          {moment(orderData.updatedAt).format('YYYY-MM-DD')}
        </DetialValue>
      </div>
      <div>
        <DetialLabel>{estimatedCompletionDate}</DetialLabel>
        <DetialValue>{completionDate}</DetialValue>
      </div>
    </div>
  );
};

Details.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.string).isRequired
};

export default Details;
